import { render, staticRenderFns } from "./freePractice.vue?vue&type=template&id=40310747&scoped=true"
import script from "./freePractice.vue?vue&type=script&lang=js"
export * from "./freePractice.vue?vue&type=script&lang=js"
import style0 from "./freePractice.vue?vue&type=style&index=0&id=40310747&prod&lang=scss"
import style1 from "./freePractice.vue?vue&type=style&index=1&id=40310747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40310747",
  null
  
)

export default component.exports